import _ from 'underscore';
import React from 'react';
import { withError } from '@bingads-webui-react/validation';
import { InputLite } from '@bingads-webui-react/primitive-validation';

export const InputWithExtra = withError(props => (
  <div className={props.containerClass}>
    <InputLite
      {..._.omit(props, 'containerClass', 'extra')}
    />
    {props.extra()}
  </div>
));
